<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              {{scopeObj.title}}
            </div>
          </v-layout>
          <div v-if="this.getDetailBasic.tag === 'B3'">
            <v-layout row wrap class="ml-2 mr-2"
            v-if="this.getDetailBasic !== ''">
              <v-flex xs12 md8 lg6>
                <v-select
                  :change="updateFormChar()"
                  v-model="owner"
                  :label="this.localForm.owner"
                  :items="ownerBusinessProcessOptions"
                  color="wplblue0"
                  prepend-icon="person"
                  hint="owner"
                  persistent-hint
                >
                </v-select>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-text-field
                :change="updateFormChar()"
                v-model="localForm.ref"
                :rules="ruleMustBeNotUndefinedANDLessThan50"
                prepend-icon="post_add"
                hint="reference"
                persistent-hint
                required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2"
            v-if="this.getDetailBasic !== ''">
              <v-flex xs12 md8 lg6>
                <v-select
                  :change="updateFormChar()"
                  v-model="active"
                  :label="this.localForm.active"
                  :items="taskActivityTypeOptions"
                  color="wplblue0"
                  prepend-icon="more_horiz"
                  hint="activity"
                  persistent-hint
                >
                </v-select>
              </v-flex>
              <v-flex xs12 md8 lg6>
                <v-select
                  :change="updateFormChar()"
                  v-model="impact"
                  :label="this.localForm.impact"
                  :items="resourcesImpactTypeOptions"
                  color="wplblue0"
                  prepend-icon="donut_large"
                  hint="impact"
                  persistent-hint
                >
                </v-select>
              </v-flex>
            </v-layout>
          </div>
          <v-layout row wrap class="ml-2 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.scope"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              :hint="scopeObj.description"
              auto-grow
              persistent-hint
              :readonly="this.getDetailBasic.tag === 'W2'"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2"
          v-if="this.getDetailBasic !== null">
            <v-flex xs12 md8 lg6
            v-if="
            this.getDetailBasic.tag !== 'F1' &&
            this.getDetailBasic.tag !== 'M5' &&
            this.getDetailBasic.tag !== 'W1' &&
            this.getDetailBasic.tag !== 'W2'
            ">
              <v-select
                :change="updateFormChar()"
                v-model="reach"
                :label="this.localForm.reach"
                :items="reachBusinessOperationsOptions"
                color="wplblue0"
                prepend-icon="trip_origin"
                :hint="scopeObj.reach"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6
            v-if="
            this.getDetailBasic.tag !== 'W1' &&
            this.getDetailBasic.tag !== 'W2' &&
            this.getDetailBasic.tag !== 'M5'
            ">
              <v-select
                :change="updateFormChar()"
                v-model="spons"
                :label="this.localForm.spons"
                :items="sponsorBusinessProcessOptions"
                color="wplblue0"
                prepend-icon="person_add_alt_1"
                :hint="scopeObj.sponsor"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2"
          v-if="this.getDetailBasic !== null && this.getDetailBasic.tag === 'S6'">
            <v-flex xs12 md8 lg6>
              <!-- <v-select
                :change="updateFormChar()"
                v-model="active"
                :label="this.localForm.active"
                :items="taskActivityTypeOptions"
                color="wplblue0"
                prepend-icon="check_box"
                hint="activity"
                persistent-hint
              >
              </v-select> -->
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="owner"
                :label="this.localForm.owner"
                :items="complexityOptions"
                color="wplblue0"
                prepend-icon="note_add"
                hint="complexity"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <div v-if="
          this.getDetailBasic.tag === 'B3' ||
          this.getDetailBasic.tag === 'E2' ||
          this.getDetailBasic.tag === 'W1' ||
          this.getDetailBasic.tag === 'W2' ||
          this.getDetailBasic.tag === 'M5'
          ">
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs12 sm6 md8 lg6>
                <v-select
                  v-model="localForm.pri"
                  :items="priorityOptions"
                  color="wplblue0"
                  required
                  prepend-icon="priority_high"
                  hint="priority"
                  persistent-hint
                  :readonly="this.getDetailBasic.tag === 'W2'"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md8 lg6
              v-if="
              this.getDetailBasic.tag === 'M5' ||
              this.getDetailBasic.tag === 'W1' ||
              this.getDetailBasic.tag === 'W2'
              ">
                <v-text-field
                :label="localForm.comp"
                prepend-icon="assured_workload"
                hint="work compliance"
                persistent-hint
                outline
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md8 lg6
              v-if="this.getDetailBasic.tag !== 'M5'">
                <DatePicker :date= "{
                  obj: 'stats.ddue',
                  label: dateTypeA(this.getDetailStats.ddue),
                  hint: 'due date',
                  icon: 'today'
                  }"
                />
              </v-flex>
            </v-layout>
          </div>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import ownerOptions from "@/data/options/mixins/ownerOptions.js";
import businessOptions from "@/data/options/mixins/businessOptions.js";
import tasksOptions from "@/data/options/mixins/tasksOptions.js";
import priorityOptions from "@/data/options/mixins/priorityOptions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import resourcesOptions from "@/data/options/mixins/resourcesOptions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import DatePicker from "@/data/functions/components/DatePicker";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        scope: "",
        spons: "",
        reach: "",
        active: "",
        owner: "",
        impact: "",
        ref: "",
        pri: "",
        comp: "NA"
      },
      orgForm: {
        scope: "",
        spons: "",
        reach: "",
        active: "",
        owner: "",
        impact: "",
        ref: "",
        pri: "",
        comp: "NA"
      },
      pri: "",
      spons: "",
      reach: "",
      active: "",
      owner: "",
      impact: ""
    };
  },
  components: {
    DatePicker
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.scope = this.getDetail.char.scope;
    this.localForm.spons = this.getDetail.char.spons;
    this.localForm.reach = this.getDetail.char.reach;
    this.localForm.active = this.getDetail.char.active;
    this.localForm.owner = this.getDetail.char.owner;
    this.localForm.ref = this.getDetail.char.ref;
    this.localForm.impact = this.getDetail.char.impact;
    this.localForm.pri = this.getDetail.char.pri;

    this.orgForm.scope = this.getDetail.char.scope;
    this.orgForm.spons = this.getDetail.char.spons;
    this.orgForm.reach = this.getDetail.char.reach;
    this.orgForm.active = this.getDetail.char.active;
    this.orgForm.owner = this.getDetail.char.owner;
    this.orgForm.ref = this.getDetail.char.ref;
    this.orgForm.impact = this.getDetail.char.impact;
    this.orgForm.pri = this.getDetail.char.pri;

    if (this.getDetailChar.comp !== "") {
      this.localForm.comp = this.getDetailChar.comp;
      this.orgForm.comp = this.getDetailChar.comp;
    }
  },
  // eslint-disable-next-line
  mixins: [
    dateFunctions,
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    ownerOptions,
    businessOptions,
    techOptions,
    tasksOptions,
    resourcesOptions,
    priorityOptions
  ],
  computed: {
    ...mapGetters([
      "getDetailBasic",
      "getDetailChar",
      "getDetailStats",
      "getCurrentPage",
      "getDetail"
    ]),
    scopeObj() {
      let obj = {
        title: "Scope of Work",
        description: "investigation scope and description",
        reach: "reach",
        sponsor: "sponsor"
      };
      if (this.getDetailBasic.tag === "B1") {
        obj.title = "Risk Assessment Scope";
        obj.description = "risk scope and limits";
        obj.reach = "risk cover";
        obj.sponsor = "risk ownership";
      }
      if (this.getDetailBasic.tag === "B3") {
        obj.title = "Action Scope";
        obj.description = "action scope and limits";
        obj.reach = "action reach";
        obj.sponsor = "action sponsor";
      }
      if (this.getDetailBasic.tag === "B4") {
        obj.title = "Budget Scope";
        obj.description = "budget scope and limits";
        obj.reach = "budget reach";
        obj.sponsor = "budget sponsor";
      }
      if (this.getDetailBasic.tag === "B6") {
        obj.title = "Plan Scope";
        obj.description = "plan scope and limits";
        obj.reach = "plan reach";
        obj.sponsor = "plan sponsor";
      }
      if (this.getDetailBasic.tag === "E2") {
        obj.title = "Engineering Request Scope";
        obj.description = "engineering scope and limits";
        obj.reach = "engineering reach";
        obj.sponsor = "engineering sponsor";
      }
      if (this.getDetailBasic.tag === "M2") {
        obj.title = "Maintenance Strategy Scope";
        obj.description = "plan scope and limits";
        obj.reach = "strategy reach";
        obj.sponsor = "strategy sponsor";
      }
      if (this.getDetailBasic.tag === "M5") {
        obj.title = "Maintenance Plan Scope";
        obj.description = "plan scope and limits";
        obj.reach = "engineering reach";
        obj.sponsor = "engineering sponsor";
      }
      if (this.getDetailBasic.tag === "E6") {
        obj.title = "Technical Result Scope of Work";
        obj.description = "results scope and limits";
        obj.reach = "results reach";
        obj.sponsor = "results sponsor";
      }
      if (this.getDetailBasic.tag === "F1") {
        obj.title = "Facility Key Equipment and Operations";
        obj.description = "facility scope, capability, operational limits";
        obj.reach = "results reach";
        obj.sponsor = "care and custody";
      }
      if (this.getDetailBasic.tag === "S6") {
        obj.title = "Risk Assessment Scope";
        obj.description = "investigation scope and description";
        obj.reach = "investigation reach";
        obj.sponsor = "sponsor";
      }
      if (this.getDetailBasic.tag === "E6") {
        obj.title = "Procedure Scope of Work";
        obj.description = "procedure scope and limits";
        obj.reach = "procedure reach";
        obj.sponsor = "procedure sponsor";
      }
      if (this.getDetailBasic.tag === "W1") {
        obj.title = "Work Request Scope";
        obj.description = "work request scope and limits";
        obj.reach = "procedure reach";
        obj.sponsor = "procedure sponsor";
      }
      if (this.getDetailBasic.tag === "W2") {
        obj.title = "Work Call Scope";
        obj.description = "work call scope and limits";
        obj.reach = "procedure reach";
        obj.sponsor = "procedure sponsor";
      }
      return obj;
    }
  },
  watch: {
    spons() {
      this.localForm.spons = this.spons;
      this.updateFormChar();
    },
    reach() {
      this.localForm.reach = this.reach;
      this.updateFormChar();
    },
    active() {
      this.localForm.active = this.active;
      this.updateFormChar();
    },
    owner() {
      this.localForm.owner = this.owner;
      this.updateFormChar();
    },
    impact() {
      this.localForm.impact = this.impact;
      this.updateFormChar();
    },
    pri() {
      this.localForm.pri = this.pri;
      this.updateFormChar();
    }
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line

      if (
        this.localForm.scope !== this.orgForm.scope &&
        this.localForm.scope !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.scope = this.localForm.scope;
        // basic
        char.scope = this.localForm.scope;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.reach !== this.orgForm.reach &&
        this.localForm.reach !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.reach = this.localForm.reach;
        // basic
        char.reach = this.localForm.reach;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.spons !== this.orgForm.spons &&
        this.localForm.spons !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.spons = this.localForm.spons;
        // basic
        char.spons = this.localForm.spons;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.active !== this.orgForm.active &&
        this.localForm.active !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.active = this.localForm.active;
        // basic
        char.active = this.localForm.active;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.owner !== this.orgForm.owner &&
        this.localForm.owner !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.owner = this.localForm.owner;
        // basic
        char.owner = this.localForm.owner;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.ref !== this.orgForm.ref &&
        this.localForm.ref !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.ref = this.localForm.ref;
        // basic
        char.ref = this.localForm.ref;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.impact !== this.orgForm.impact &&
        this.localForm.impact !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.impact = this.localForm.impact;
        // basic
        char.impact = this.localForm.impact;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.pri !== this.orgForm.pri &&
        this.localForm.pri !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.pri = this.localForm.pri;
        // basic
        char.pri = this.localForm.pri;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
